/** Blob folder for PvE / Hunting Lodge crafting materials (blacksmith recipes). */
export const CRAFT_ITEMS_BASE =
  'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/craft_items/'

const ITEMS_BASE = 'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/items/'

/** Inventory `item` keys — align with API / blacksmith `requirements.gems`. */
export const CRAFT_MATERIAL_ITEM_KEYS = [
  'ancient-core',
  'blood-stone',
  'cloth',
  'crystal-dust',
  'demon-eye',
  'dragon-fang',
  'dragon-heart',
  'dragon-squama',
  'flame-core',
  'herb',
  'hydra-fang',
  'ice-crystal',
  'leather',
  'phoenix-feather',
  'rhinoceros-horn',
  'shadow-essence',
  'soul-jar',
  'thread',
  'titan-bone',
  'void-shard',
  'world-tree-seed',
] as const

const CRAFT_KEY_SET = new Set<string>(CRAFT_MATERIAL_ITEM_KEYS)

export function normalizeInventoryItemKey(raw: string): string {
  const n = raw.trim().toLowerCase().replace(/_/g, '-')
  // Legacy: plain "feather" was renamed to phoenix-feather in recipes and assets
  if (n === 'feather') return 'phoenix-feather'
  return n
}

export function isCraftMaterialItem(itemKey: string): boolean {
  return CRAFT_KEY_SET.has(normalizeInventoryItemKey(itemKey))
}

/** Gems and crafting materials: standard gems use `items/`, craft materials use `craft_items/`.
 *  Protection shields (droppable grade-1 + shop grades) use the world-map shield badge asset. */
export function getInventoryGemImageUrl(itemKey: string): string {
  const key = normalizeInventoryItemKey(itemKey)
  if (/^protection-shield-[1-5]$/.test(key)) {
    return `${process.env.PUBLIC_URL || ''}/assets/maps/castle-shield.webp`
  }
  if (CRAFT_KEY_SET.has(key)) {
    return `${CRAFT_ITEMS_BASE}${key}.webp`
  }
  return `${ITEMS_BASE}${key}.webp`
}
